import { baseSaga } from 'src/store/baseSaga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { apiGetModalInfo } from 'src/api/plusSubscriptionPlanSelection';
import { plusSubscriptionSlice, PlusSubscriptionSliceStateType } from 'src/store/plusSubscription/slice';
import { PromiseReturnType } from 'src/utils/types';
import { PlusSubscriptionModalTypeEnum } from 'src/models/plusSubscription';
import { currentUserSlice } from 'src/store/user/slice';
import { PayloadAction } from '@reduxjs/toolkit';
import { UserModel } from 'src/models/Account/User';

function* getModalInfo() {
  yield baseSaga(function* () {
    if (window.managedCampaignSettings?.isCreatedByAdmin) {
      return;
    }

    const response: PromiseReturnType<typeof apiGetModalInfo> = yield call(apiGetModalInfo);

    yield put(plusSubscriptionSlice.actions.getModalInfoOk(response));

    let type: PlusSubscriptionSliceStateType['modal']['type'] = null;
    let canClose = false;

    if (
      response.PlusSubscriptionModalType === PlusSubscriptionModalTypeEnum.PlanSelection &&
      response.PlanSelectionModalInfo
    ) {
      type = response.PlanSelectionModalInfo.IsFreeTrialExpired ? 'trialExpired' : 'planSelection';
    }

    if (
      response.PlusSubscriptionModalType === PlusSubscriptionModalTypeEnum.PaymentFailed &&
      response.FailedPaymentModalInfo
    ) {
      type = 'paymentFailed';
      canClose = !response.FailedPaymentModalInfo.IsGracePeriodExpired;
    }

    if (response.PlusSubscriptionModalType === PlusSubscriptionModalTypeEnum.PlanPreselected) {
      type = 'planPreselected';
      canClose = false;
    }

    if (type) {
      yield put(plusSubscriptionSlice.actions.showModal({ type, canClose }));
    }
  }, plusSubscriptionSlice.actions.getModalInfoError);
}

function* getModalInfoStart({ payload }: PayloadAction<UserModel | null>) {
  if (payload) {
    yield call(getModalInfo);
  }
}

export function* PlusSubscriptionSagas(): Generator {
  yield takeLatest(currentUserSlice.actions.getCurrentUserOk.type, getModalInfoStart);
}
